import { Component } from '@angular/core';
import { NavParams } from 'ionic-angular';

declare var dataLayer: Array<any>;

@Component({
  selector: 'page-session-detail',
  templateUrl: 'session-detail.html'
})
export class SessionDetailPage {
  session: any;

  constructor(public navParams: NavParams) {
    this.session = navParams.data.session;
  }


  ionViewDidLoad() {
    dataLayer.push({
      'screenPath': 'session-detail',
      'screenName': 'SessionDetailPage'
    });
    dataLayer.push({'event': 'appScreenView'});
  }
}



// WEBPACK FOOTER //
// ./src/pages/session-detail/session-detail.ts